export default __webpack_public_path__ + "static/media/close.4feba88c.svg";